export function isServerSide() {
  if (typeof window !== "undefined") {
    return false;
  }
  return true;
}

export function isDev() {
  return process.env.NODE_ENV !== "production";
}

// Check if the browser is Safari
export function isSafari() {
  return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
}
export function isIOS() {
  return /iPad|iPhone|iPod/.test(navigator.userAgent);
}
